import { lazy } from "react";

const AddTestUsers = lazy(() => import("./AddTestUsers"));
const Organizations = lazy(() => import("./Organizations"));
const OrganizationsDetails = lazy(() => import("./OrganizationsDetails"));
const CreateOrganization = lazy(() => import("./CreateOrganization"));
const Users = lazy(() => import("./Users"));
const ManageAdmins = lazy(() => import("./ManageAdmins"));
const UsersInvitations = lazy(() => import("./UsersInvitations"));
const Login = lazy(() => import("./Login"));
const SuhailBadges = lazy(() => import("./SuhailBadges"));
const ComplaintsList = lazy(() => import("./ComplaintsList"));
const SuhailNotifications = lazy(() => import("./SuhailNotifications"));
const OffersList = lazy(() => import("./OffersList"));

export {
  AddTestUsers,
  Organizations,
  OrganizationsDetails,
  CreateOrganization,
  Users,
  ManageAdmins,
  UsersInvitations,
  Login,
  SuhailBadges,
  ComplaintsList,
  SuhailNotifications,
  OffersList,
};
